import { useState, useEffect } from "react";
import { ExternalLink, X } from "lucide-react";

const PRODUCT_URL = "https://bioinfinity.co/retatrutide/glp3-r";
const CODE = "RETA20";

export default function StickyConversionBar() {
  const [dismissed, setDismissed] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (dismissed || !visible) return null;

  return (
    <div
      data-testid="sticky-conversion-bar"
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-[#0d2f59]"
      style={{ background: "#113C6E" }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center justify-between gap-4">
        <p className="text-sm text-white/90 hidden sm:block">
          Ready to begin research? Get <strong className="text-white">20% off</strong> Retatrutide (GLP3-R)
          at BioInfinity Lab with code{" "}
          <span className="font-mono font-bold text-sky-300">{CODE}</span>
        </p>
        <p className="text-sm text-white/90 sm:hidden">
          <strong>20% off</strong> GLP3-R — code{" "}
          <span className="font-mono font-bold text-sky-300">{CODE}</span>
        </p>
        <div className="flex items-center gap-2 flex-shrink-0">
          <a
            href={PRODUCT_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="sticky-bar-shop-btn"
            className="btn-lift inline-flex items-center gap-1.5 px-4 py-1.5 bg-white text-[#113C6E] text-sm font-bold rounded-full hover:bg-sky-50 transition-colors"
          >
            Shop Now
            <ExternalLink className="h-3 w-3" />
          </a>
          <button
            onClick={() => setDismissed(true)}
            data-testid="sticky-bar-dismiss"
            className="p-1 text-white/50 hover:text-white transition-colors"
            aria-label="Dismiss"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
